/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';



// WEBPACK FOOTER //
// ./src/containers/LanguageProvider/constants.js